module.exports = __webpack_public_path__ + "static/media/quiz.7baabeca.svg";